import combinedGACall from '../combinedGACall';

export default (action) =>
	combinedGACall({
		category: 'Navigation',
		action,
	});
